const cookieName = "Api_key";

export const setApiKey = (apiKey) => {
  if (typeof apiKey !== "string" || !apiKey) {
    throw new Error("Missing API key");
  }
  const cookie = `${cookieName}=${encodeURIComponent(apiKey)}`;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${cookie}; Path=/; Max-Age=2592000; SameSite=Lax${secure}`;
  if (!document.cookie.split(";").some((item) => item.trim() === cookie)) {
    throw new Error("Unable to save the API key cookie");
  }
  localStorage.removeItem(cookieName);
};

export const getApiKey = () => {
  const cookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(`${cookieName}=`));
  if (cookie) {
    try {
      return decodeURIComponent(cookie.slice(cookieName.length + 1)) || null;
    } catch {
      return null;
    }
  }
  // Move existing sessions to cookies on their first authenticated request.
  const apiKey = localStorage.getItem(cookieName);
  if (apiKey) {
    setApiKey(apiKey);
  }
  return apiKey;
};

export const clearApiKey = () => {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${cookieName}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
  localStorage.removeItem(cookieName);
};
